import React from 'react'
import PropTypes from 'prop-types'
import CSS from './index.module.css'
import iconAdd1 from '@assets/icon/icon_add1.png'
import iconAdd2 from '@assets/icon/icon_add2.png'
import iconSubtract1 from '@assets/icon/icon_subtract1.png'
import iconSubtract2 from '@assets/icon/icon_subtract2.png'
import iconAdd11 from '@assets/icon/icon_add11.png'
import iconAdd22 from '@assets/icon/icon_add22.png'
import iconSubtract11 from '@assets/icon/icon_subtract11.png'
import iconSubtract22 from '@assets/icon/icon_subtract22.png'

class Stepper extends React.Component {
	state = {
		iconType: this.props.iconType || 1,
		count: this.props.initCount === 0 ? 0 : this.props.initCount || 1,
		canAdd: this.props.initCount < this.props.maxCount,
		canSubtract: this.props.initCount > this.props.minCount,
	}

	refresh() {
		this.setState({
			count: this.props.initCount || 1,
		})
		if (this.props.initCount < this.props.maxCount) {
			this.setState({
				canAdd: true,
			})
		} else {
			this.setState({
				canAdd: false,
			})
		}
		if (this.props.initCount > this.props.minCount) {
			this.setState({
				canSubtract: true,
			})
		} else {
			this.setState({
				canSubtract: false,
			})
		}
	}

	addCountAction() {
		let count = this.state.count
		this.props.addValue && this.props.addValue(count + 1)
		if (count >= this.props.maxCount) {
			this.setState({
				canAdd: false,
			})
		} else {
			if (count + 1 >= this.props.maxCount) {
				this.setState({
					count: count + 1,
					canAdd: false,
					canSubtract: true,
				})
			} else {
				this.setState({
					count: count + 1,
					canAdd: true,
					canSubtract: true,
				})
			}
			this.props.changeValue(count + 1)
		}
	}
	subtractCountAction() {
		let count = this.state.count
		this.props.subtractValue && this.props.subtractValue(count - 1)
		if (count <= this.props.minCount) {
			this.setState({
				canSubtract: false,
			})
		} else {
			if (count - 1 <= this.props.minCount) {
				this.setState({
					count: count - 1,
					canAdd: true,
					canSubtract: false,
				})
			} else {
				this.setState({
					count: count - 1,
					canAdd: true,
					canSubtract: true,
				})
			}
			this.props.changeValue(count - 1)
		}
	}

	render() {
		let iconAdd = iconAdd1
		let iconAddDisable = iconAdd2
		let iconSubtract = iconSubtract1
		let iconSubtractDisable = iconSubtract2
		if (+this.state.iconType === 2) {
			iconAdd = iconAdd11
			iconAddDisable = iconAdd22
			iconSubtract = iconSubtract11
			iconSubtractDisable = iconSubtract22
		}

		return (
			<div className={`${this.props.className} ${CSS.section}`}>
				<img
					className={CSS.cellImg}
					src={this.state.canSubtract ? iconSubtract : iconSubtractDisable}
					onClick={this.subtractCountAction.bind(this)}
					alt=''
				/>
				<p className={CSS.cellContent}>{this.state.count}</p>
				<img
					className={CSS.cellImg}
					src={this.state.canAdd ? iconAdd : iconAddDisable}
					onClick={this.addCountAction.bind(this)}
					alt=''
				/>
			</div>
		)
	}
}

Stepper.propTypes = {
	iconType: PropTypes.number,
	className: PropTypes.string,
	initCount: PropTypes.number,
	minCount: PropTypes.number,
	maxCount: PropTypes.number,
	addValue: PropTypes.func,
	subtractValue: PropTypes.func,
	changeValue: PropTypes.func,
}

Stepper.defaultProps = {
	iconType: 1,
	initCount: 1,
	minCount: 1,
	maxCount: 9999,
}

export default Stepper
